export default function CTASection() {
  const { t } = useTranslation();
  return (
    <section
      className="relative py-28 overflow-hidden"
      style={{
        backgroundImage: 'url(https://images.unsplash.com/photo-1451187580459-43490279c0fa?auto=format&fit=crop&w=1920&q=80)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed',
      }}
    >
      <div className="absolute inset-0 bg-slate-900/80" />
      <div className="absolute inset-0 bg-gradient-to-br from-primary-900/60 to-slate-900/60" />
      {/* Decorative glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-primary-600/20 rounded-full blur-3xl pointer-events-none" />

      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="inline-flex items-center gap-2 bg-primary-500/20 border border-primary-500/30 rounded-full px-4 py-1.5 mb-6">
          <span className="w-1.5 h-1.5 rounded-full bg-primary-400 animate-pulse" />
          <span className="text-primary-300 text-sm font-medium">emailaze.com</span>
        </div>
        <h2 className="font-display text-4xl sm:text-5xl font-bold text-white mb-4 drop-shadow-lg">
          {t('home.cta_title')}
        </h2>
        <p className="text-white/60 text-lg mb-10">{t('home.cta_subtitle')}</p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/register"
            className="inline-flex items-center justify-center gap-2 bg-primary-500 hover:bg-primary-400 text-white font-semibold px-10 py-4 rounded-full transition-all shadow-lg shadow-primary-900/50 hover:shadow-xl hover:shadow-primary-800/50 text-base"
          >
            {t('home.cta_btn')}
            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </Link>
          <Link
            to="/pricing"
            className="inline-flex items-center justify-center gap-2 border border-white/25 text-white/80 hover:bg-white/10 font-medium px-8 py-4 rounded-full transition-all text-base"
          >
            {t('nav.pricing')}
          </Link>
        </div>
      </div>
    </section>
  );
}
